export const report_invoice_lang = {
  TH: {
    month_search: "ค้นหาข้อมูลใบแจ้งหนี้",
    month_searchh: "ค้นหารายการยกเลิกใบแจ้งหนี้",
    choose_year: "เลือกปี",
    choose_month: "เลือกเดือน",
    choose_type_report: "เลือกช่วงเวลา",
    choose_day: "เลือกวัน",
    all_bill: "ใบเสร็จรับเงินทั้งหมด",
    total_bill: "ยอดรวมทั้งหมด",
    header_table: "ข้อมูลสถานที่ผู้เสียค่าธรรมเนียม",
    search: "ค้นหา",
    place_id: "รหัสที่อยู่",
    place_desc: "ที่อยู่/บ้านเลขที่",
    place_type_desc: "ชนิดที่อยู่",
    customer_name: "ชื่อผู้เสียภาษี",
    place_address: "ที่อยู่",
    fee_type_description: "ประเภทค่าธรรมเนียม",
    fee_type_unit: "รายละเอียดค่าธรรมเนียม",
    back_to_detail:"กลับไปยังหน้ารายละเอียด",
    place_count: "จำนวนบ้าน",
    show_detail: "แสดงรายละเอียด",
    back: "ย้อนกลับ",
    bill_id: "รหัสใบเสร็จรับเงิน",
    bill_desc: "รายละเอียด",
    bill_date: "วันที่ออกเอกสาร",
    bill_user: "ผู้ออกเอกสาร",
    bill_discount: "ส่วนลด",
    bill_total_price: "ยอดที่ต้องชำระ",
    bill_payment_desc: "ประเภทการชำระ",
    print_invoice: "พิมพ์ใบแจ้งหนี้",
    due_date: "กำหนดชำระ",
    status_code: "สถานะการชำระ",
    report_count: "จำนวนใบแจ้งหนี้ : ",
    report_price: "ยอดรวมค่าธรรมเนียม : ",
    report_count_cancel: "จำนวนใบแจ้งหนี้ที่ยกเลิก : ",
    request_general_id: "หมายเลขคำร้อง",
    request_alert: "กรุณากรอกหมายเลขคำร้อง",
    cancel_invoice: "ยกเลิกใบแจ้งหนี้",
    cancel_title: "ต้องการยกเลิกใบแจ้งหนี้นี้ใช่หรือไม่?",
    cancel_detail: "กรุณายืนยันข้อมูล",
    show_invoice: "แสดงใบแจ้งหนี้",
    invoice_id: "รหัสใบแจ้งหนี้",
    fee_id: "รหัสค่าธรรมเนียม",
    fee_description: "รายละเอียดค่าธรรมเนียม",
    customer_id: "รหัสลูกค้า",
    user_id: "ผู้ออกใบ",
    create_datetime: "วันที่ออกใบแจ้งหนี้",
    total_price: "ราคารวม",
    fee_price: "ค่าธรรมเนียม",
    want_delete: "ฉันต้องการลบ",
    confirm_delete: "คุณต้องการลบข้อมูลใบแจ้งหนี้นี้ใช่หรือไม่?",
    warining_delete: "ข้อมูลลบลบแล้วไม่สามารถยอนกลับได้!!",
    close: "ปิดหน้านี้",
    deleted: "ยกเลิกใบแจ้งหนี้ เรียบร้อยแล้ว",
    print_invoice_3x4: "พิมพ์ใบเสร็จรับเงินขนาดพกพา",
    gen_type_name:"ประเภทการชำระเงิน",
    type_pay:"เลือกสถานะการชำระเงิน",
    date_start: 'เลือกวันเริ่มต้น/สิ้นสุด'

  },
  EN: {
    print_invoice_3x4: "Pocket size receipt printing",
    month_search: "search by year/month/day",
    gen_type_name:"Type fee",
    choose_year: "choose year",
    choose_month: "choose month",
    back_to_detail:"back to detail",
    date_start:'Select start/end date',
    choose_type_report: "choose time report",
    choose_day: "choose day",
    all_bill: "All Invoices",
    total_bill: "Total Invoices",
    place_count:"place count",
    search: "Search",
    place_id: "Place ID",
    place_desc: "Place Desc",
    place_type_desc: "Place Type",
    customer_name: "Customer Name",
    place_address: "Address",
    fee_type_description: "Fee Description",
    fee_type_unit: "Fee",
    show_detail: "Detail",
    back: "Back",
    bill_id: "Invoice Id",
    bill_desc: "Invoice Detail",
    bill_date: "Invoice Date",
    bill_user: "User Make",
    print_invoice: "Print Invoice",
    due_date: "Due Date",
    status_code: "Status",
    report_count: "Total Invoice : ",
    report_price: "Total Price Invoice : ",
    report_count_cancel: "Total Invoice (Cancel) : ",
    request_general_id: "request general id",
    request_alert: "please input request general id",
    cancel_invoice: "Cancel",
    cancel_title: "Are you sure to cancel this invoice??",
    cancel_detail: "Please confirm.",
    show_invoice: "Show Invoice",
    invoice_id: "Invoice Id",
    fee_id: "Fee Id",
    fee_description: "Fee decription",
    customer_id: "Customer Id",
    user_id: "User Id",
    create_datetime: "Create Datetime",
    total_price: "Total Price",
    fee_price: "Fee Price",
    want_delete: "Yes delete it",
    confirm_delete: "Are you sure to delete this invoice item?",
    warining_delete: "Deleted data can't recovery!",
    close: "Close",
    deleted: "Cancel invoice success",
    type_pay:"select type",
    bill_total_price: "Amount to be paid",

  }
}
